module.exports = __webpack_public_path__ + "static/media/failed@3x.47bdce37.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/failed@3x.png
// module id = 682
// module chunks = 0